import { Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Directive()
export class DodoComponent implements OnDestroy {
	protected _unsubscribeAll: Subject<any>;

	constructor() {
		this._unsubscribeAll = new Subject();
	}

	ngOnDestroy() {
		this._unsubscribeAll.next(void 0);
		this._unsubscribeAll.complete();
	}
}
